"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _classnames = _interopRequireDefault(require("classnames"));
require("./in-context-help.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InContextHelp = props => {
  const {
    type,
    title,
    children,
    className,
    style,
    drawerPlacement
  } = props;
  const [toggled, setToggle] = (0, _react.useState)(false);
  const toggle = () => {
    setToggle(!toggled);
  };
  if (type === 'drawer') {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('in-context-help', 'in-context-help-drawer', className),
      style: style
    }, /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, {
      className: "question-circle-button",
      onClick: toggle
    }), /*#__PURE__*/_react.default.createElement(_antd.Drawer, {
      placement: drawerPlacement,
      title: title,
      open: toggled,
      destroyOnClose: true,
      onClose: toggle
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 30
      }
    }, children)));
  } else if (type === 'tooltip') {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('in-context-help', 'in-context-help-tooltip', className),
      style: style
    }, /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
      title: children
    }, /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, {
      className: "question-circle-button"
    })));
  }
};
InContextHelp.propTypes = {
  type: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  drawerPlacement: _propTypes.default.string
};
var _default = exports.default = InContextHelp;
//# sourceMappingURL=in-context-help.js.map